export const selectCurrentLocale = state => state.getIn(['Language', 'currentLocale']);
